<template>
  <div class="app-main">
    <div class="content-search-title" v-if="buttonEnable">
      <span style="font-size: 18px; font-weight: bold;">共需转账&nbsp;<span style="color: #20a0ff;">{{ total }}</span>&nbsp;笔，请核对记录</span>
      <el-button @click="payEnable(1)" type="primary" style="margin-left: 40px;">{{ ischeck ? "审核通过" : "核对通过" }}</el-button>
      <el-button @click="payEnable(0)" type="primary" style="margin-left: 20px;">{{ ischeck ? "审核不通过" : "核对不通过" }}</el-button>
      <el-button @click="downloadExcel" type="primary" style="margin-left: 20px;">下载excel文件</el-button>
    </div>
    <div class="content-search-title" v-else>
      <el-button @click="downloadExcel" type="primary" style="margin-left: 20px;">下载excel文件</el-button>
    </div>
    <div class="content-table">
      <el-table :data="paydetails" size='medium' tooltip-effect="dark">
        <el-table-column prop="id" label="序号" width="100px" />
        <el-table-column prop="uname" label="姓名" />
        <el-table-column prop="uprovider" label="供应商" show-overflow-tooltip />
        <el-table-column prop="umoney" label="税前金额" align="center" width="100px"></el-table-column>
        <el-table-column prop="finalPayAmount" label="实发金额" align="center" width="100px" v-if="isPersonalTax == 1"></el-table-column>
        <el-table-column prop="personalTax" label="所得税" align="center" width="100px" v-if="isPersonalTax == 1"></el-table-column>
        <el-table-column prop="personalInfo" label="所得税详情" align="center" width="150px" v-if="isPersonalTax == 1"  show-overflow-tooltip></el-table-column>
        <el-table-column prop="ucardid" label="身份证号"></el-table-column>
        <el-table-column prop="uphone" label="手机号"></el-table-column>
        <el-table-column prop="ubank" label="开户银行" show-overflow-tooltip></el-table-column>
        <el-table-column prop="ubankcard" label="银行卡号"></el-table-column>
        <el-table-column prop="umonth" label="发放月份"></el-table-column>
        <el-table-column prop="remark" label="转账备注" show-overflow-tooltip></el-table-column>
        <el-table-column prop="status" label="取消转账" width="200px" align="center" v-if="status === 0">
          <template slot-scope="scope">
            <!-- <div class="detail-name" @click="changePayStatus(scope.row, 1)">复核中</div> -->
            <el-switch v-model="scope.row.payCancel" @change="payChangeStatus(scope.row)" />
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="content-pagination fr" v-if="total > pageSize">
      <el-pagination @current-change="handleChange" :current-page.sync="currentPage" :page-size="pageSize" layout="prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import api from '@/api/api';
import detailnavbar from './detailnavbar';

export default {
  name: 'paydetail',
  components: {
    detailnavbar,
  },
  data() {
    return {
      title: '',
      paydetails: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      opId: '',
      payStatus: 4,
      status: 0,
      buttonEnable: false,
      ischeck: 0,
      isPersonalTax: false,
    };
  },
  mounted() {
    this.opId = this.$route.query.opId;
    this.ischeck = this.$route.query.ischeck;
    console.log('ischeck', this.ischeck);
    this.status = this.$route.query.status;
    if (this.status === 2 || this.status === 4) {
      this.buttonEnable = false;
    } else {
      this.buttonEnable = true;
    }
    this.fetchExcelDetail();
  },
  methods: {
    fetchExcelDetail() {
      api.fetchExcelDetail({
        params: {
          params: {
            // payStatus: this.payStatus,
            index: this.currentPage - 1,
            size: this.pageSize,
            opId: this.opId,
          },
        },
      }).then((res) => {
        this.paydetails = res.data;
        this.paydetails.forEach((paydetail) => {
          paydetail.payCancel = paydetail.payStatus === 3;
        });
        this.total = res.count;
        this.isPersonalTax = res.isPersonalTax;
      }).catch((err) => {
        console.log(err);
        this.$message({
          type: 'error',
          message: err.response.message,
        });
      });
    },
    handleChange(index) {
      this.currentPage = index;
      this.fetchExcelDetail();
    },
    payEnable(ispass) {
      if (this.status === 0) {
        this.status = (ispass === 1 ? 1 : 2);
      } else if (this.status === 1) {
        this.status = (ispass === 1 ? 3 : 4);
      } else if (this.status === 3) {
        this.status = 5;
      }
      api.payEnable({
        params: {
          params: {
            opId: this.opId,
            status: this.status,
            ispass,
          },
        },
      }).then(() => {
        this.$message({
          type: 'success',
          message: '操作成功',
        });
        this.$router.push({ path: 'layout' });
      }).catch((err) => {
        console.log(err);
        this.$message({
          type: 'error',
          message: err.response.message,
        });
      });
    },
    downloadExcel() {
      // eslint-disable-next-line
      window.location = `/paywages/api/excel/export?opId=` + this.opId;
    },
    payChangeStatus(row) {
      const tranIds = [];
      tranIds.push(row.tranId);
      api.payChangeStatus({
        params: {
          data: {
            tranIds,
            status: row.payCancel === true ? 1 : 0,
          },
        },
      }).then(() => {
        this.$message({
          type: 'success',
          message: '操作成功',
        });
        // this.$router.push({ path: 'layout' });
      }).catch((err) => {
        console.log(err);
        this.$message({
          type: 'error',
          message: err.response.message,
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>

@media screen and (max-width: 1200px) {
  .app-main {
    width: 100%;
  }
}
@media screen and (min-width: 1200px) {
  .app-main {
    width: 100%;
  }
}

.app-main {
}
.content-tool {
  padding: 27px 17px 20px 17px;
  border: 1px solid #ebeef5;
  background: #fff;
  font-size: 14px;
  color: #606266;
  overflow: hidden;
  margin: 40px 20px 0px 20px;
  .content-tool--nav {
    display: inline-block;
    vertical-align: middle;
    width: 20%;
    padding: 0 10px;
    .content-tool--title {
      width: 56px;
      margin-right: 10px;
      height: 36px;
      line-height: 36px;
      font-size: 14px;
      text-align: right;
    }
    .content-tool--input {
      width: calc(100% - 66px);
      height: 36px;
    }
  }
}
.content-tool--operate {
  padding: 30px 17px 10px 17px;
  background: #fff;
  font-size: 14px;
  color: #606266;
  overflow: hidden;
  margin: 0px 20px 0px 20px;
}
.content-search-title {
  overflow: hidden;
  border-bottom: 1px solid #ebeef5;
  padding: 30px 30px 10px 30px;
  letter-spacing: 2px;
  .search {
    height: 80px;
    border: 1px solid #fff;
  }
  .content-table--title {
    font-size: 15px;
    letter-spacing: 2px;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
    .record-num {
      color: #20a0ff;
    }
  }
  .search-title {
    margin: 0 50px 0 20px;
  }
  .color-bule {
    color: #0779bd;
  }
}
.fr {
  float: right;
}
.fl {
  float: left;
}
.content-table {
  margin: 30px;
  font-size: 15px;
  .detail-name {
    color: #20a0ff;
    cursor: pointer;
    text-decoration: underline;
  }
}
.content-pagination {
  padding: 20px 40px 0 0;
}
</style>




// WEBPACK FOOTER //
// src/components/payimport.vue